module.exports = __webpack_public_path__ + "img/weddings_04_H.c1e1c65a.jpg";